import { axios, AxiosResponse } from '~/modules'
import {
  IFetchUrineCultureTestByParams,
  IUrineCultureTest,
  IAntibiotic,
  IFetchAntibioticsParams,
  IFetchLaboratoryTestsParams,
  ILaboratoryTest,
  ILaboratoryTestProperty,
  IFetchLaboratoryTestPropertiesParams,
  IFetchLaboratoryTestParamsById
} from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchUrineCultureTests = async (params: IFetchUrineCultureTestByParams): Promise<IUrineCultureTest[]> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.patientId}/laboratory-health-procedures`)
  const { data }: AxiosResponse<IUrineCultureTest[]> = response
  return data
}

export const fetchAntibiotics = async (params: IFetchAntibioticsParams): Promise<IAntibiotic[]> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.patientId}/antibiotics`)
  const { data }: AxiosResponse<IAntibiotic[]> = response
  return data
}

export const fetchLaboratoryTests = async (params: IFetchLaboratoryTestsParams): Promise<ILaboratoryTest[]> => {
  const { pathParams, queryParams } = params

  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.patientId}/laboratory-tests`, {
    params: queryParams
  })
  const { data }: AxiosResponse<ILaboratoryTest[]> = response
  return data
}

export const fetchLaboratoryTestById = async (params: IFetchLaboratoryTestParamsById): Promise<ILaboratoryTest> => {
  const response = await axios.get(`${hstoryAPI}/laboratory-tests/${params.testId}`)
  const { data }: AxiosResponse<ILaboratoryTest> = response
  return data
}

export const fetchLaboratoryTestProperties = async (
  params: IFetchLaboratoryTestPropertiesParams
): Promise<ILaboratoryTestProperty[]> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/laboratory-tests/${pathParams.testId}/properties`)
  const { data }: AxiosResponse<ILaboratoryTestProperty[]> = response
  return data
}
